<script>
//import VAutocompleteBigData from "@/components/VAutocomplete/VAutocompleteBigData.vue";
import AjaxLoad from "@/components/commonComponents/AjaxLoad.vue";
import roscongressUrl from "@/utils/roscongressUrl";
import _ from "lodash";
import VIconTooltip from "@/components/commonComponents/VIconTooltip.vue";

export default {
    name: "VAutocompleteSession",
    inheritAttrs: false,
    components: {
        VIconTooltip,
        AjaxLoad,
        //VAutocompleteBigData,
    },
    props: {
        value: {},
        idProject: {
            type: String,
            required: true,
        },
        disabled: {
            type: Boolean,
        },
        idEventsBitrix: {
            type: Number,
        },
        idForumsBitrix: {
            type: Number,
        },
    },
    data() {
        return {
            dictionaries: {
                sessions: [],
            },
        };
    },
    computed: {
        syncValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
            },
        },
        sessionsOrderedByActiveDesc() {
            return _.orderBy(this.dictionaries.sessions, ['is_active'], ['desc']);
        },
        selectedItem() {
            return _.find(this.sessionsOrderedByActiveDesc, {id_session_eps: this.syncValue});
        },
        sessionRoscongressUrl() {
            const selectedItem = this.selectedItem;
            return selectedItem && roscongressUrl.getSessionUrl(selectedItem);
        },
        sessionRoscongressBitrixUrl() {
            const selectedItem = this.selectedItem;
            return selectedItem && roscongressUrl.getSessionBitrixUrl(selectedItem);
        },
        sessionRoscongressCmsRoute() {
            const selectedItem = this.selectedItem && Object.assign(
                {},
                _.pickBy({
                    ID_FORUM: this.idForumsBitrix,
                    ID_EVENT: this.idEventsBitrix,
                }, _.isNumber),
                this.selectedItem
            );
            return selectedItem && roscongressUrl.getSessionCmsRoute(selectedItem);
        },
    },
    watch: {
        selectedItem(v) {
            this.$emit('update:id-sessions', v?.id_sessions);
            this.$emit('update:id-session-bitrix', v?.id_session_bitrix);
        },
    },
    methods: {},
    beforeDestroy() {
        this.currentSession = null;
    },
}
</script>

<template>
    <ajax-load
        v-model="dictionaries.sessions"
        :url="$apiUrl.getProjectDictionarySessionsUrl({id_project: idProject})"
        :transform="response => response.data.data"
        v-slot="{resolved}"
    >
        <v-autocomplete
            v-model="syncValue"
            v-bind="$attrs"
            v-on="$listeners"
            :items="sessionsOrderedByActiveDesc"
            :loading="!resolved || undefined"
            :class="[$vnode.data.class, $vnode.data.staticClass]"
            :disabled="disabled"
            item-text="name"
            item-value="id_session_eps"
        >
            <template v-slot:append>
                <v-icon-tooltip
                    v-if="sessionRoscongressUrl"
                    :href="sessionRoscongressUrl"
                    @click.stop
                    icon="mdi-web-check"
                    target="_blank"
                >
                    Открыть сессию на Портале
                </v-icon-tooltip>

                <v-icon-tooltip
                    v-if="sessionRoscongressBitrixUrl"
                    :href="sessionRoscongressBitrixUrl"
                    @click.stop
                    icon="$ls-web-cog"
                    target="_blank"
                    class="ls-svg"
                >
                    Открыть сессию в Битрикс
                </v-icon-tooltip>

                <v-icon-tooltip
                    v-if="sessionRoscongressCmsRoute"
                    :to="sessionRoscongressCmsRoute"
                    @click.stop
                    icon="$ls-web-arrow-right-circle"
                    target="_blank"
                    class="ls-svg"
                >
                    Открыть сессию в ESS
                </v-icon-tooltip>
                <div class="v-input__icon v-input__icon--append">
                    <v-icon :disabled="disabled">mdi-menu-down</v-icon>
                </div>
            </template>
        </v-autocomplete>
    </ajax-load>
</template>

<style scoped lang="scss">
//>>> .v-btn {
//    margin: -6px 0;
//}

::v-deep {
    .v-btn {
        margin: -0px 0;
        height: 24px;
        width: 24px;

        &.v-btn--icon {
            .v-icon {
                &.mdi-web, &.mdi-web-check, &.mdi-filter, &.mdi-filter-off {
                    font-size: 22px;
                }
                &.ls-svg {
                    width: 22px;
                    height: 22px;
                }
            }
        }
    }
}

</style>
